import { Card, CardContent, Container, Grid, Typography } from "@mui/material";
import React, { ChangeEvent, SyntheticEvent, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import { useUser } from "../../contexts/UserContext";
import authService from "../../services/auth-service";
import ProfileForm from "./ProfileForm";
import userService from "../../services/user-service";

const ProfileComponent: React.FC = () => {
  const { user, userId, userRole, handleLogout } = useUser();
  const [content] = useState<string>("");
  const [userReady, setUserReady] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    phonenumber: "",
    city: "",
    country: "",
    email: "",
    username: "",
  });

  useEffect(() => {
    const fetchUserData = async () => {
      setUserReady(false);
      try {
        if (user && userId) {
          setFormData({
            name: user.name || "",
            surname: user.surname || "",
            phonenumber: user.phonenumber || "",
            city: user.city || "",
            country: user.country || "",
            email: user.email || "",
            username: user.username || "",
          });
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
      } finally {
        setUserReady(true);
      }
    };
    fetchUserData();
  }, [handleLogout, user, userId]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCountryChange = (
    event: SyntheticEvent,
    newValue: string | null
  ) => {
    setFormData({ ...formData, country: newValue || "" });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    try {
      e.preventDefault();
      const user = authService.getCurrentUser();
      if (!user || !user) {
        console.error("User not logged in or missing ID");
        return;
      }

      const profileContent = {
        id: userId,
        name: formData.name,
        surname: formData.surname,
        phonenumber: formData.phonenumber,
        city: formData.city,
        country: formData.country,
      };
      await userService.updateProfile(userId, profileContent);
      toast.info("Profile updated!", { position: "bottom-right" });
      userService.getUserInfoById(userId);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };
  return (
    <Container sx={{ paddingTop: "40px" }}>
      {user && userReady ? (
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h3" gutterBottom>
              <FormattedMessage id="hello" /> {user.name} ({user.username})
            </Typography>
          </Grid>
          <Grid item xs={12} paddingBottom={2}>
            <Card>
              <CardContent>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>
                    <FormattedMessage id="name" />:
                  </strong>{" "}
                  {user.name} {user.surname}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>
                    <FormattedMessage id="username" />:
                  </strong>{" "}
                  {user.username}
                </Typography>

                <Typography variant="subtitle1" gutterBottom>
                  <strong>
                    <FormattedMessage id="phone" />:
                  </strong>{" "}
                  {user.phonenumber}
                </Typography>

                <Typography variant="subtitle1" gutterBottom>
                  <strong>
                    <FormattedMessage id="location" />:
                  </strong>{" "}
                  {user.city}, {user.country}
                </Typography>

                <Typography variant="subtitle1" gutterBottom>
                  <strong>
                    <FormattedMessage id="email" />:
                  </strong>{" "}
                  {user.email}
                </Typography>

                <Typography variant="subtitle1" gutterBottom>
                  <strong>
                    <FormattedMessage id="privilages" />:
                  </strong>
                </Typography>

                <Typography fontSize={30}>{userRole}</Typography>
              </CardContent>
            </Card>
          </Grid>
          <ProfileForm
            formData={formData}
            handleChange={handleChange}
            handleCountryChange={handleCountryChange}
            handleSubmit={handleSubmit}
          />
        </Grid>
      ) : (
        <Grid item justifyContent={"center"} alignItems={"center"}>
          <Typography variant="h4" gutterBottom>
            <strong>{content}</strong>
          </Typography>
        </Grid>
      )}
    </Container>
  );
};
export default ProfileComponent;
